import { useEffect } from "react";

import { atom, useAtom } from "../app-jotai";

export type MicMode = "smart" | "raw";

const STORAGE_KEY = "ideaweave-mic-mode";

const getStoredMicMode = (): MicMode => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "smart" || stored === "raw") {
      return stored;
    }
  } catch {
    // localStorage unavailable
  }
  return "smart";
};

export const micModeAtom = atom<MicMode>(getStoredMicMode());

export const useMicMode = () => {
  const [micMode, setMicMode] = useAtom(micModeAtom);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, micMode);
    } catch {
      // localStorage unavailable
    }
  }, [micMode]);

  return [micMode, setMicMode] as const;
};
